import ClassroomsService from "@/services/ClassroomsService";
import { replaceItemInList, removeItemFromList, findItemInList, getListItems, getListPagination } from "@/utils/listHelpers";
import { getApiErrorMessage, notifyStoreError } from "@/utils/storeHelpers";
export default {
    namespaced: true,
    state: {
        classroomsData: [],
        status: null,
    },
    getters: {
        getClassroomsData: (state) => getListItems(state.classroomsData),
        getClassroomsPagination: (state) => getListPagination(state.classroomsData),
        getStatus: (state) => state.status,
    },
    mutations: {
        setClassroomsData(state, data) {
            state.classroomsData = data;
        },
        setStatus(state, status) {
            state.status = status;
        },
        createClassroomInList(state, classroom) {
            if (!classroom)
                return;
            if (Array.isArray(state.classroomsData)) {
                state.classroomsData.push(classroom);
            }
            else if (state.classroomsData?.data && Array.isArray(state.classroomsData.data)) {
                state.classroomsData.data.push(classroom);
            }
        },
    },
    actions: {
        async getClassrooms({ commit, dispatch }, payload) {
            try {
                const response = await ClassroomsService.getClassrooms(payload.data, payload.userToken);
                commit('setClassroomsData', response);
            }
            catch (error) {
                console.error('Erro ao buscar turmas', error);
                commit('setStatus', getApiErrorMessage(error, 'Erro ao buscar turmas'));
            }
            finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true });
                }
            }
        },
        async createClassroom({ commit, dispatch }, payload) {
            let createdClassroom = null;
            try {
                const response = await ClassroomsService.createClassroom(payload.classroom, payload.userToken);
                createdClassroom = response.data;
            }
            catch (error) {
                notifyStoreError(dispatch, 'Erro ao adicionar turma', error);
                throw error;
            }
            if (!createdClassroom) {
                throw new Error('Erro ao adicionar turma');
            }
            try {
                const settingResponse = await ClassroomsService.createClassroomSetting({
                    ...payload.setting,
                    classroom_id: createdClassroom.id
                }, payload.userToken);
                const classroomWithSetting = { ...createdClassroom, setting: settingResponse.data };
                commit('createClassroomInList', classroomWithSetting);
                dispatch('toastfy/activeSuccesNotification', { text: 'Turma adicionada com sucesso' }, { root: true });
                return classroomWithSetting;
            }
            catch (error) {
                commit('createClassroomInList', createdClassroom);
                notifyStoreError(dispatch, 'Turma criada, mas as configurações falharam — edite a turma para configurá-la', error);
                throw error;
            }
        },
        async updateClassroom({ commit, state, dispatch }, payload) {
            try {
                const response = await ClassroomsService.updateClassroom(payload.classroom, payload.userToken);
                const updatedClassroom = response.data;
                let resolvedSetting = updatedClassroom.setting;
                if (payload.setting) {
                    const settingResponse = payload.setting.id
                        ? await ClassroomsService.updateClassroomSetting({ ...payload.setting, classroom_id: updatedClassroom.id }, payload.userToken)
                        : await ClassroomsService.createClassroomSetting({ ...payload.setting, classroom_id: updatedClassroom.id }, payload.userToken);
                    resolvedSetting = settingResponse.data;
                }
                const existingClassroom = findItemInList(state.classroomsData, updatedClassroom.id);
                const keepsPaymentPlan = updatedClassroom.payment_plan_id === existingClassroom?.payment_plan_id;
                const classroomWithSetting = {
                    ...existingClassroom,
                    ...updatedClassroom,
                    curriculum: updatedClassroom.curriculum ?? existingClassroom?.curriculum ?? null,
                    course: updatedClassroom.course ?? existingClassroom?.course ?? null,
                    payment_plan: updatedClassroom.payment_plan ?? (keepsPaymentPlan ? existingClassroom?.payment_plan : null) ?? null,
                    setting: resolvedSetting ?? existingClassroom?.setting ?? null
                };
                dispatch('toastfy/activeSuccesNotification', { text: 'Turma atualizada com sucesso' }, { root: true });
                commit('setClassroomsData', replaceItemInList(state.classroomsData, classroomWithSetting));
                return classroomWithSetting;
            }
            catch (error) {
                notifyStoreError(dispatch, 'Erro ao atualizar turma', error);
                throw error;
            }
        },
        async deleteClassroom({ commit, state, dispatch }, payload) {
            try {
                await ClassroomsService.deleteClassroom(payload.data, payload.userToken);
                dispatch('toastfy/activeSuccesNotification', { text: 'Turma deletada com sucesso' }, { root: true });
                commit('setClassroomsData', removeItemFromList(state.classroomsData, payload.data));
            }
            catch (error) {
                notifyStoreError(dispatch, 'Erro ao deletar turma', error);
            }
        },
    }
};
